exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".published-date{display:block;color:#002e3e;font-size:.6875rem;line-height:.8125rem;text-align:left}@media (min-width:0) and (max-width:1023px){.published-date{text-align:center}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":"/app/assets/scss/global/global.scss"}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/node/fields/Date.vue
// module id = 797
// module chunks = 6 42 43 53 54 55 57 58 59 60 61 63 64 65 66 67 68 69 73 75 78 90